var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('h3',{staticClass:"heading"},[_vm._v(_vm._s(_vm.page.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }